import React, { memo } from 'react';
import icons from '@icons';
import { Picture } from '@ui';
import { declension } from '@utils/declension';
import './index.scss';
import { LazyLoadImage } from '@components/reactLazyLoadImageComponent';
const {
  checkmark: { red: checkmarkRedOutlined, green: checkmarkGreenOutlined }
} = icons.Outline;
const {
  calendar: { white: calendarWhiteFilled }
} = icons.Fill;
const TaskCard = ({ task, openModal, activate }) => {
  const activateTask = async e => {
    e.stopPropagation();
    await activate?.(task);
  };
  return (
    <div
      className={`task-card${!openModal ? ' task-card--default' : ''}`}
      onClick={openModal}
    >
      <div className='task-card__img-wrapper'>
        {task.type === 'progress' && (
          <div className='task-card__date'>
            <Picture icon={calendarWhiteFilled} width='16' height='16' />
            {declension(task.days, ['Остался', 'Осталось', 'Осталось'])}{' '}
            {task.days} {declension(task.days, ['день', 'дня', 'дней'])}
          </div>
        )}
        <LazyLoadImage
          src={task?.fileItem?.cacheItem?.[0]?.filePath || task.image}
          alt={task.name}
          className='task-card__img'
        />
        {task.type === 'progress' && (
          <div className='task-card__status'>Выполняется</div>
        )}
      </div>
      <div className='task-card__info'>
        <div className='task-card__bonuses'>+{task.amount} ₽ бонусов</div>
        <div className='task-card__text'>{task.name}</div>
      </div>
      {task.type === 'complete' ? (
        <div className='task-card__label task-card__label--green'>
          <Picture icon={checkmarkGreenOutlined} width='16' height='16' />
          Выполнено
        </div>
      ) : task.type === 'progress' ? (
        <div className='task-card__label task-card__label--red'>
          <Picture icon={checkmarkRedOutlined} width='16' height='16' />
          Активировано
        </div>
      ) : (
        <div className='task-card__btn' onClick={activateTask}>
          Активировать
        </div>
      )}
    </div>
  );
};

export default memo(TaskCard);
